import styled from "styled-components";
import {Avatar} from "@mui/material";
import {media, breakpoints} from "../../theme";

export const UserSettingsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
    padding: 20px;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
`;

export const CenteredHeader = styled(Header)`
    justify-content: center;

    h2 {
        margin: 0;
    }
`;

export const AvatarContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 150px;
    height: 150px;
    gap: 10px;
    margin: auto;

    @media (max-width: ${breakpoints.md}) {
        height: 100%;
    }
`;

export const StyledAvatar = styled(Avatar)`
    width: 150px !important;
    height: 150px !important;
    margin: 0 !important;
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    width: 100%;
    margin-top: 24px;

    ${media.md} {
        margin-top: auto;
    }
`;

export const FormSection = styled.div`
    margin-top: 20px;
    width: 100%;
`;

export const SectionTitle = styled.h3`
    margin-bottom: 16px;
    font-weight: 500;
    color: #333;
`;
